module.exports = __webpack_public_path__ + "img/foodtype-french.c1a83229.png";